// extracted by mini-css-extract-plugin
module.exports = {"button":"FollowSearchButton__button__47777c0e"};